import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import axiosInstance from "utils/axiosInstance";
import { useLocalStorage } from "utils/storage";
import { setUserData } from "services/auth";

const Login = () => {
    sessionStorage.clear();
    
    const navigate = useNavigate();

    const [token, setToken] = useLocalStorage('token');

    const [form, setForm] = useState({
        email: "",
        password: "",
    });
    const [error, setError] = useState("");

    const handleInputChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await axiosInstance.post("/api/auth/login", form);

            setToken(response.data.token);
            setUserData(response.data);

            navigate("/notches");
        } catch (err) {
            setError(err.response?.data?.message || "Login failed.");
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100"
            // style={{ transform: "translateX(25%)" }}
        >
            <div className="w-100" style={{ maxWidth: "400px" }}>
                <div className="card shadow-lg p-4">
                    <h3 className="text-center mb-4">Login</h3>
                    <form onSubmit={handleLogin}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={form.email}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={form.password}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                            />
                        </div>
                        {error && (
                            <div className="mb-3 text-danger text-center">
                                {error}
                            </div>
                        )}
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary btn-lg">
                                Login
                            </button>
                        </div>
                    </form>
                    <div className="text-center mt-3">
                        <p>
                            Don't have an account? <Link to="/register">Register</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
